import { UserRoles } from '@utils/constants';
import React from 'react';
import { useIntl } from 'react-intl';
import DateRangePicker from '../../../../components/Common/DateRangePicker/DateRangePicker';
import MultiplePicker from '../../../../components/Common/MultiplePicker/MultiplePicker';
import messages from '../messages';

export function Filters({
  tours,
  profiles,
  selectedTours,
  setSelectedTours,
  selectedProfiles,
  setSelectedProfiles,
  dateRange,
  setDateRange,
  userRole,
  groupBy,
  setGroupBy,
  onExportCSV
}) {
  const intl = useIntl();

  const displayTours = tours || [];
  const displayProfiles = profiles || [];

  const isInvalidRange = dateRange?.start && dateRange?.end && new Date(dateRange.start).getTime() > new Date(dateRange.end).getTime();

  return (
    <div className="w-full">
      <div className="flex flex-col lg:flex-row gap-6 items-end justify-between w-full">
        
        <div className="flex flex-wrap items-end gap-6 w-full lg:w-auto">
          <div className="w-48 shrink-0">
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Select Tours</label>
            <div className="bg-white rounded-lg border border-solid border-slate-200 hover:border-slate-300 shadow-sm transition-all h-[42px]">
              <MultiplePicker
                items={displayTours}
                getTitle={item => item.title || item.displayName || item.name || 'Unknown Tour'}
                getValue={item => item._id || item.id || item}
                selectedItems={selectedTours}
                setSelectedItems={setSelectedTours}
                defaultOptionLabel={intl.formatMessage(messages.allTours)}
              />
            </div>
          </div>
          
          {userRole === UserRoles.admin && (
            <div className="w-48 shrink-0">
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Select Users</label>
              <div className="bg-white rounded-lg border border-solid border-slate-200 hover:border-slate-300 shadow-sm transition-all h-[42px]">
                <MultiplePicker
                  items={displayProfiles}
                  getTitle={item => `${item.firstName} ${item.lastName}`}
                  getValue={item => item.userId}
                  selectedItems={selectedProfiles}
                  setSelectedItems={setSelectedProfiles}
                  defaultOptionLabel={intl.formatMessage(messages.allProfiles)}
                />
              </div>
            </div>
          )}

          <div className="shrink-0">
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Date Range</label>
            <div className={`bg-white rounded-lg border border-solid shadow-sm transition-all h-[42px] px-3 flex items-center gap-2 ${isInvalidRange ? 'border-rose-300 hover:border-rose-400 bg-rose-50/10' : 'border-slate-200 hover:border-slate-300'}`}>
              <svg className={`w-4 h-4 shrink-0 pointer-events-none ${isInvalidRange ? 'text-rose-400' : 'text-slate-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <DateRangePicker
                dateRange={dateRange}
                setDateRange={setDateRange}
              />
            </div>
            {isInvalidRange && (
              <span className="block text-[11px] font-semibold text-rose-500 mt-1.5 ml-1">
                Start date must be before end date
              </span>
            )}
          </div>
        </div>

        <div className="flex flex-wrap items-end gap-6 w-full lg:w-auto mt-4 lg:mt-0">
          <div className="w-48 shrink-0">
            <span className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Breakdown Mode</span>
            <div className="bg-white rounded-lg border border-solid border-slate-200 hover:border-slate-300 shadow-sm transition-all h-[42px] px-3.5 flex items-center justify-between gap-2">
              <span className={`text-sm font-bold transition-colors ${groupBy === 'tour' ? 'text-indigo-600' : 'text-slate-400'}`}>Tours</span>
              <button 
                onClick={() => setGroupBy(groupBy === 'tour' ? 'guide' : 'tour')}
                className="relative inline-flex h-6 w-11 items-center rounded-full bg-slate-200 p-0 border-none cursor-pointer transition-colors focus:outline-none shrink-0"
              >
                <span className={`inline-block h-4 w-4 transform rounded-full bg-indigo-600 transition-transform duration-300 ease-in-out shadow-sm ${groupBy === 'guide' ? 'translate-x-[26px]' : 'translate-x-[2px]'}`} />
              </button>
              <span className={`text-sm font-bold transition-colors ${groupBy === 'guide' ? 'text-indigo-600' : 'text-slate-400'}`}>Users</span>
            </div>
          </div>

          <div className="w-48 shrink-0">
             <span className="block text-xs font-bold text-transparent uppercase tracking-wider mb-2 select-none" aria-hidden="true">Export</span>
             <button 
                onClick={onExportCSV}
                className="w-full bg-white rounded-lg border border-solid border-slate-200 hover:border-slate-300 hover:bg-slate-50 shadow-sm transition-all h-[42px] flex items-center justify-center gap-2 text-slate-700 font-medium text-sm whitespace-nowrap cursor-pointer p-0"
              >
                <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Export CSV
              </button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Filters;
